import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { ButtonsWrapper } from '../../AllLanguages/AllLanguages.style';
import { EditableTableRowState } from 'src/components/TranslationsContent/SelectedLanguage/EditableTableRow/EditableTableRow.state';
import { GroupName } from '../../TranslationsContent.state';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

type Props = {
    language: string;
    onCancel: (e: React.MouseEvent) => void;
    onUpdate: () => Promise<void>;
    translationKey: string;
    translationValue: string;
    uniqueKeys: string[];
    groupName: GroupName;
};
export type EditableTableRowProps = Props;

export const EditableTableRow = observer('EditableTableRow', (props: Props) => {
    const [state] = useState(() => new EditableTableRowState(props));

    return (
        <tr key={state.props.translationKey}>
            <td>
                <input type='text' value={state.key} onChange={state.onKeyChange} />
            </td>
            <td>
                <input
                    data-key={state.props.translationKey}
                    id='focused'
                    onChange={state.onValueChange}
                    type='text'
                    value={state.value}
                />
            </td>
            {state.saving ? (
                <td>
                    <div className='spinner spinner--inline spinner-small' />
                </td>
            ) : (
                <td>
                    <ButtonsWrapper>
                        <Button onClick={state.props.onCancel} size='small' version='secondary'>
                            Cancel
                        </Button>
                        <Button onClick={state.onDeleteClick} size='small' version='secondary'>
                            Delete
                        </Button>
                        <Button onClick={state.onSaveClick} size='small'>
                            Save
                        </Button>
                    </ButtonsWrapper>
                </td>
            )}
        </tr>
    );
});
